<template>
  <div>
    <div class="header-time-box">
      评审时间：{{ reviewStartTime }} — {{ reviewEndTime }}
    </div>
    <div class="header-search-box flex align-items-center border-box">
      <div class="flex flex-4 align-items-center">
        <div>学校名称 :</div>
        <input
          class="input-style"
          type="text"
          v-model="queryCriteria.schoolName"
        />
      </div>
      <div class="flex align-items-center">
        <div v-if="type === 'szStudio'">工作室名称：</div>
        <div v-if="type === 'educationalBrand'">特色文化育人品牌名称：</div>
        <div v-if="type === 'szMicroClass'">思政微课名称：</div>
        <input class="input-style" type="text" v-model="queryCriteria.name" />
      </div>
      <div class="flex align-items-center">
        <div>项目负责人 :</div>
        <input
          class="input-style"
          type="text"
          v-model="queryCriteria.principals"
        />
      </div>
      <div class="flex align-items-center">
        <div>资料完整：</div>
        <a-select
          default-value="全部"
          style="width: 120px"
          @change="handleChange"
        >
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="0"> 完整 </a-select-option>
          <a-select-option value="1"> 未完整 </a-select-option>
        </a-select>
      </div>
      <div
        class="search-btn flex flex-center align-items-center"
        @click="goQuery"
      >
        <img class="img-box" src="../../assets/images/img48.png" alt="" />
        <div>查询</div>
      </div>
    </div>
    <div class="text1">
      当前共有<span class="color-red"> {{ schoolCount }} </span>所学校，<span
        class="color-red"
      >
        {{ applyCount }} </span
      >个{{ wokrName }}
    </div>
    <div class="expert-table-box">
      <a-table
        style="text-align: center"
        :locale="{ emptyText: '暂无数据' }"
        :pagination="pagination"
        :columns="columns"
        :data-source="data"
        :bordered="true"
        rowKey="id"
        @change="handleTableChange"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <span class="flex flex-around" slot="action" slot-scope="record">
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="review(record)"
          >
            <img class="img-box" src="../../assets/images/img56.png" alt="" />
            {{ getPreviewTimeout(record)
            }}<!-- ? "审核" : "查看" -->
          </div>
        </span>
        <template slot="applyFilesFull" slot-scope="text">
          <img
            v-if="text == 0"
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt=""
            title="资料完整"
          />
          <img
            v-else
            class="img-box-hint c-p"
            src="../../assets/images/img58.png"
            alt=""
            title="资料不完整"
          />
        </template>
        <template slot="duration" slot-scope="text">
          <img
            v-if="
              (text / 1000 / 60).toFixed(0) >= 5 &&
              (text / 1000 / 60).toFixed(0) <= 10
            "
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt=""
            :title="getTime(text) + '\n时长合格'"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt=""
            :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在5-10分钟内`
            "
          />
        </template>
        <template slot="applyScoreFile" slot-scope="text">
          <span v-if="text == '-'">-</span>
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img51.png"
            :title="text"
            style="cursor: pointer"
            @click="preview(text)"
          />
        </template>
      </a-table>
    </div>
    <div class="preview-pop-box" v-if="showPreviewPop">
      <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <preview
          ref="preview"
          type="expert"
          @closePreview="showPreviewPop = false"
          @goNewPage="goNewPage"
          @submitPreview="submitPreview"
          :previewTimeout="previewTimeout"
          :preViewData="preViewData"
          @submit="submit"
          :evaluationTablePreview="evaluationTablePreview"
        ></preview>
      </div>
    </div>
    <preview-img
      :visibles="visibles"
      :url="url"
      @handleCancel="visibles = false"
    ></preview-img>
  </div>
</template>

<script>
import { lxExpertApplyReview } from "@/api/index";
import { formatDuring } from "../../utils/time";
import preview from "./preview";
import previewImg from "../previewImg.vue";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "工作室名称",
    dataIndex: "name",
    key: "name",
    align: "center",
    width: 220,
  },
  {
    title: "学校",
    dataIndex: "realname",
    key: "realname",
    align: "center",
    width: 220,
  },
  {
    title: "项目负责人",
    dataIndex: "principals",
    key: "principals",
    align: "center",
    width: 120,
  },
  {
    title: "联系电话",
    dataIndex: "phone",
    key: "phone",
    align: "center",
    width: 120,
  },
  {
    title: "资料完整",
    dataIndex: "applyFilesFull",
    id: "applyFilesFull",
    align: "center",
    scopedSlots: { customRender: "applyFilesFull" },
    width: 100,
  },
  {
    title: "分数",
    dataIndex: "score",
    key: "score",
    align: "center",
    width: 80,
  },
  // {
  //   title: "评审表",
  //   dataIndex: "scoreFile",
  //   key: "scoreFile",
  //   align: "center",
  //   scopedSlots: { customRender: "applyScoreFile" },
  //   width: 80,
  // },
  {
    title: "操作",
    key: "action",
    align: "center",
    width: 100,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "",
  components: {
    preview,
    previewImg,
  },
  props: {
    columns: {
      type: Array,
      default: () => columns,
    },
    title: String,
    reviewStartTimestamp: {
      type: String,
      default: "",
    },
    reviewEndTimestamp: {
      type: String,
      default: "",
    },
    reviewStartTime: {
      type: String,
      default: "",
    },
    reviewEndTime: {
      type: String,
      default: "",
    },
    timestampStartTime: {
      type: String,
      default: "",
    },
    timestampEndTime: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
    },
    type: String,
    wokrName: {
      type: String,
      default: "",
    },
    applyCount: {
      type: Number,
    },
    schoolCount: {
      type: Number,
    },
    pagination: {
      type: Object,
    },
  },
  data() {
    return {
      showPreviewPop: false,
      url: "",
      visibles: false,
      queryCriteria: {
        name: "",
        schoolName: "",
        principals: "",
        Integrity: "",
      },
      fullscreen: false,
      previewTimeout: false,
      preViewData: [],
      evaluationTablePreview: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getTime(time) {
      return formatDuring(time);
    },
    handleChange(value) {
      this.queryCriteria.Integrity = value;
    },
    getPreviewTimeout() {
      // record
      // if (record.score === null || record.score === '-') {
      //   return "评审";
      // } else {
      //   return "查看";
      // }
      var date1 = new Date();
      var timestamp = Date.parse(date1);
      if (
        timestamp > this.reviewStartTimestamp &&
        timestamp < this.reviewEndTimestamp
      ) {
        this.previewTimeout = true;
        return "评审";
      } else {
        this.previewTimeout = false;
        return "查看";
      }
    },
    review(row) {
      this.preViewData = row;
      var date1 = new Date();
      var timestamp = Date.parse(date1);
      if (timestamp < this.reviewStartTimestamp) {
        if (row.score === null) {
          this.$message.warning("评审时间还没开始");
        } else {
          this.showPreviewPop = true;
        }
      } else if (timestamp > this.reviewEndTimestamp) {
        this.showPreviewPop = true;
        this.$message.warning("评审时间已经结束");
      } else if (
        timestamp > this.reviewStartTimestamp &&
        timestamp < this.reviewEndTimestamp
      ) {
        this.showPreviewPop = true;
        this.previewTimeout = true;
        if (row.score === null) {
          this.$message.success("开始评审");
          this.evaluationTablePreview = false;
        }
      }
    },
    preview(item) {
      // this.url = "";
      // this.visibles = true;
      // this.url = item;
      this.preViewData = item;
      this.showPreviewPop = true;
      // 评审表预览
      this.evaluationTablePreview = true;
      this.$nextTick(() => {
        this.$refs.preview.review();
      });
    },
    goQuery() {
      const pagination = {
        current: 1,
        pageSize: 20,
      };
      this.handleTableChange(pagination);
    },
    goNewPage(flag) {
      console.log(flag);
      this.fullscreen = flag;
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      let queryParam = {};
      queryParam.page = pagination.current;
      queryParam.size = pagination.pageSize;
      queryParam.realname = this.queryCriteria.schoolName;
      queryParam.name = this.queryCriteria.name;
      queryParam.principals = this.queryCriteria.principals;
      queryParam.Integrity = this.queryCriteria.Integrity;
      this.$emit("getApplyZjApplyList", queryParam);
    },
    submitPreview(data) {
      lxExpertApplyReview(data).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.showPreviewPop = false;
          this.$emit("updataInfo");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 评审提交
    submit() {
      this.showPreviewPop = false;
      this.$emit("reviewSubmit");
    },
  },
};
</script>

<style scoped lang="scss">
.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  .input-style {
    width: 140px;
    height: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 8px 12px;
    margin: 0 20px 0 6px;
  }
  .search-btn {
    width: 100px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #2155b5;
    border-radius: 10px;
    margin-left: 10px;
    margin-right: 20px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: rgba(156, 3, 5, 0.1);
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2155b5;
  border-radius: 10px;
}
.color-red {
  color: #2155b5;
}
.text1 {
  margin: 18px 0 11px 0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
/*
.expert-table-box
 {
}*/
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-hint {
  width: 18px;
  height: 18px;
  margin-right: 9px;
  display: inline-block;
  margin: 0 auto;
}
</style> 